/* eslint-disable react/prop-types */
import React from 'react';
import { Typography } from 'antd';

import money from '../../../helpers/money';

const { Text } = Typography;

const successColor = (success) => ((success) ? 'normal-color' : 'error-color');

const parseDate = (date) => {
  const day = Number(date.slice(0, 2));
  const month = (Number(date.slice(2, 4)) - 1);
  const year = Number(date.slice(4));
  const parsedDate = new Date(Date.UTC(year, month, day));
  return parsedDate.toLocaleDateString(undefined, { timeZone: 'UTC' });
};

const summaryColumns = {
  internal: [
    {
      title: 'Lana URL',
      dataIndex: '',
      key: 'lana_url',
      render: ({ valid, lana_id }) => (
        <Text className={successColor(valid)}>
          {lana_id}
        </Text>
      ),
    },
    {
      title: 'Name',
      dataIndex: '',
      key: 'name',
      render: ({ valid, name }) => (
        <Text className={successColor(valid)}>{name}</Text>
      ),
    },
    {
      title: 'Description',
      dataIndex: '',
      key: 'description',
      render: ({ valid, description }) => (
        <Text className={successColor(valid)}>
          {description}
        </Text>
      ),
    },
    {
      title: 'Amount',
      dataIndex: '',
      key: 'amount',
      render: ({ valid, amount, currency }) => (
        <Text className={successColor(valid)}>
          {money.toDisplay(amount, currency, false)}
        </Text>
      ),
    },
    {
      title: 'Currency',
      dataIndex: '',
      key: 'currency',
      render: ({ valid, currency }) => (
        <Text className={successColor(valid)}>
          {currency}
        </Text>
      ),
    },
    {
      title: 'Validation',
      dataIndex: '',
      key: 'validation',
      render: ({ valid, validation }) => (
        <Text className={successColor(valid)}>
          {validation || 'valid'}
        </Text>
      ),
    },
  ],
  outbound: [
    {
      title: 'Rut',
      dataIndex: '',
      key: 'rut',
      render: ({ valid, ident, check_digit: checkDigit }) => (
        <Text className={successColor(valid)}>
          {ident}-{checkDigit}
        </Text>
      ),
    },
    {
      title: 'Name',
      dataIndex: '',
      key: 'name',
      render: ({ valid, name }) => (
        <Text className={successColor(valid)}>{name}</Text>
      ),
    },
    {
      title: 'Date',
      dataIndex: '',
      key: 'date',
      render: ({ valid, date }) => (
        <Text className={successColor(valid)}>{parseDate(date)}</Text>
      ),
    },
    {
      title: 'Amount',
      dataIndex: '',
      key: 'amount',
      render: ({ valid, amount, currency }) => (
        <Text className={successColor(valid)}>
          {money.toDisplay(amount, currency || 'CLP', false)}
        </Text>
      ),
    },
    {
      title: 'Validation',
      dataIndex: '',
      key: 'validation',
      render: ({ valid, validation }) => (
        <Text className={successColor(valid)}>
          {validation || 'valid'}
        </Text>
      ),
    },
  ],
};

export { summaryColumns };
